import css from "styled-jsx/css";
import { TABLET_QUERY_MIN_WIDTH } from "/constants/vp-sizes";

export const componentStyles = css.global`
  .search-page-content-component {
    .banner-wrapper {
      display: none;
    }

    .mobile-navigation-wrapper {
      display: none;
    }
  }

  @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
    .search-page-content-component {
      .banner-wrapper {
        display: block;
      }
      .template-list-wrapper {
        margin-top: 36px;
      }

      .mobile-navigation-wrapper {
        display: flex;
        width: 100%;
        margin-top: 24px;
      }
    }
  }
`;
